import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=562c23f8&"
import script from "./js/Index.js?vue&type=script&lang=js&"
export * from "./js/Index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports